module.exports = __webpack_public_path__ + "img/reference-icon.95c8f408.svg";